<template>
	<div>
		<!--h2>Here’s what your postcard<br> looks like</h2-->
		<form>
			<h3>Add your details</h3>

			<base-input type="text" name="name" v-model="from.name" :validate="'required'" :class="{'error': errors.has('name') || profanityError}">Name</base-input>
			<base-input type="email" name="email" v-model="from.email" :validate="'required|email'">Email Address</base-input>
			<base-input type="text" name="phone" v-model="from.phone" :validate="'numeric'">Phone Number (Optional)</base-input>

			<base-checkbox name="publish" v-model="from.publish">Display my message on the Wall of giving</base-checkbox>

			<h3>I would also like to make a tax deductible donation</h3>

			<div class="flex">
				<base-radio name="donation" value="10" @change="val => donation = val" :selected="$store.state.form.donation === 10" />
				<base-radio name="donation" value="20" @change="val => donation = val" :selected="$store.state.form.donation === 20" />
				<base-radio name="donation" value="50" @change="val => donation = val" :selected="$store.state.form.donation === 50" />
				<base-radio name="donation" value="70" @change="val => donation = val" :selected="$store.state.form.donation === 70" />
				<base-radio name="donation" value="100" @change="val => donation = val" :selected="$store.state.form.donation === 100" />
			</div>

			<div v-if="$store.state.form.gift + donation > 0">
				<h3>Payments Details</h3>
				<div :class="{'form-input': true, 'form-input--stripe': true, 'no-empty': true, 'error': !cardValid}">
					<card-number class='stripe-element card-number'
						:stripe='constants.STRIPE_KEY'
						:options='stripeOptions'
						@change='cardValid = $event.complete'
						@focus="ccNumberFocus = true"
						@blur="ccNumberFocus = false"
					/>
					<label>Credit Card Number</label>
				</div>

				<div class="two-col">
					<div :class="{'form-input': true, 'form-input--stripe': true, 'no-empty': true, 'error': !expiryValid}">
						<card-expiry class='stripe-element card-expiry'
							:stripe='constants.STRIPE_KEY'
							:options='stripeOptions'
							@change='expiryValid = $event.complete'
							@focus="ccExpiryFocus = true"
							@blur="ccExpiryFocus = false"
						/>
						<label>Expiry Date</label>
					</div>
					<div :class="{'form-input': true, 'form-input--stripe': true, 'no-empty': true, 'error': !cvcValid}">
						<card-cvc class='stripe-element card-cvc'
							:stripe='constants.STRIPE_KEY'
							:options='stripeOptions'
							@change='cvcValid = $event.complete'
							@focus="ccCvcFocus = true"
							@blur="ccCvcFocus = false"
						/>
						<label>Control Number</label>
					</div>
				</div>
			</div>

			<div class="security">
				<img src="../../assets/images/ico-lock.svg" alt="Payments are secured" height="20">
				<a href="https://stripe.com/about" target="_blank"><img src="../../assets/images/ico-stripe.svg" alt="Powered & Secured by Stripe"></a>
			</div>

			<div class="total">
				<table>
					<caption>Total</caption>
					<tr>
						<th>Gift</th>
						<td>${{$store.state.form.gift}}</td>
					</tr>
					<tr>
						<th>Donation</th>
						<td>${{donation}}</td>
					</tr>
				</table>
			</div>
			<p class="error-message" v-if="errors.count() > 0">
				There has been an error with your details, please review and try again.
			</p>
			<p class="error-message" v-if="submitError">
				We could not save your data. Please, try again or contact us directly.<br>
				Error: {{submitError}}
			</p>
			</p>
			<p class="error-message" v-if="profanityError">
				Please, be nice!
			</p>
			<div class="buttons">
				<button-left @click.native.prevent="$emit('back')">Back</button-left>
				<button-right @click.native.prevent="submit" :class="{loading: formSubmitted}">Pay</button-right>
			</div>
		</form>
	</div>
</template>

<script>
import { CardNumber, CardExpiry, CardCvc, createToken } from 'vue-stripe-elements-plus';
import axios from 'axios';
import * as constants from '@/constants';
import ButtonRight from '../ButtonRight';
import ButtonLeft from '../ButtonLeft';
import BaseInput from '../BaseInput';
import BaseCheckbox from '../BaseCheckbox';
import BaseRadio from '../BaseRadio';

export default {
	$_veeValidate: {
		validator: 'new', // give me a new validator each time.
	},
	components: { BaseInput, BaseCheckbox, BaseRadio, ButtonRight, ButtonLeft, CardNumber, CardExpiry, CardCvc },
	computed: {
		constants: () => constants,
	},
	data () {
		return {
			formSubmitted: false,
			submitError: '',
			profanityError: false,
			stripeOptions: {
				style: {
					base: {
						color: '#424242',
						fontWeight: 600,
						fontFamily: 'Inter UI, Open Sans, Segoe UI, sans-serif',
						fontSize: window.innerWidth > 720 ? '15px' : '16px',
						fontSmoothing: 'antialiased',
						'::placeholder': {
							color: '#909090',
						},
					},
					invalid: {
						color: '#E43D6E',
					},
				},
			},
			from: {
				name: '',
				email: '',
				phone: '',
				publish: true,
			},
			donation: 0,

			cardValid: true,
			expiryValid: true,
			cvcValid: true,

			/** CC input focus toggles -> has to be simple var, there's a bug if this is a nested object */
			ccNumberFocus: false,
			ccExpiryFocus: false,
			ccCvcFocus: false,
		};
	},
	watch: {
		from: {
			handler: function (val) {
				this.$store.commit('formPayment', {
					from: { ...val },
					donation: this.donation,
				});
			},
			deep: true,
		},
		donation (val) {
			this.$store.commit('formPayment', {
				from: { ...this.from },
				donation: this.donation,
			});
		},
	},
	mounted () {
		this.from = {
			name: this.$store.getters.debug ? 'name' : this.$store.state.form.from.name,
			email: this.$store.getters.debug ? 'email@email.tld' : this.$store.state.form.from.email,
			phone: this.$store.getters.debug ? '123456789' : this.$store.state.form.from.phone,
			publish: this.$store.getters.debug ? true : this.$store.state.form.from.publish,
		};
		this.card = {
			number: this.$store.getters.debug ? '4242424242424242' : '',
			name: this.$store.getters.debug ? 'Card Name' : '',
			cvc: this.$store.getters.debug ? '123' : '',
			expiry: this.$store.getters.debug ? '1222' : '',
		};
		this.donation = this.$store.getters.debug ? 0 : this.$store.state.form.donation;
	},
	methods: {
		async submit (e) {
			this.$emit('success');
			return;

			if (this.formSubmitted) {
				return;
			}

			this.profanityError = false;
			this.formSubmitted = true;

			const profanity = await axios.get(`${constants.API_URL}/profanity/filter/${this.from.name}`);
			if (profanity && profanity.status === 200 && profanity.data) {
				if (profanity.data.status === 'error') {
					this.profanityError = true;
					this.formSubmitted = false;
					return;
				}
			} else {
				this.profanityError = true;
				this.formSubmitted = false;
				return;
			}

			const validationResult = await this.$validator.validateAll();
			if (!validationResult) {
				this.formSubmitted = false;
				return;
			}

			let token = null;
			let error = null;
			if (this.$store.state.form.gift + this.donation > 0) {
				// eslint-disable-next-line
				({token, error} = await createToken());
				if (error || !token.id) {
					this.formSubmitted = false;
					this.submitError = error.message;
					console.warn(error);
					return;
				}
			}

			this.$store.commit('formPayment', {
				from: this.from,
				donation: this.donation,
				payment: token,
			});

			const apiResult = await axios.post(`${constants.API_URL}/save/`, this.$store.state.form);
			if (apiResult && apiResult.status === 200 && apiResult.data) {
				if (apiResult.data.status === 'ok') {
					this.$store.commit('totalEntries', apiResult.data.entries);
					this.$emit('success');
				}
				if (apiResult.data.status === 'error') {
					this.submitError = apiResult.data.message;
				}
			} else {
				this.submitError = apiResult.statusText;
			}

			this.formSubmitted = false;
		},
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../../assets/less/default.less';
	@import '../../assets/less/form.less';
	@import '../../assets/less/form-input.less';

	h3 { .regular(); margin-top: 3rem; font-size: 1rem; }

	.two-col, .flex { display: flex; justify-content: space-between; }
	.two-col {
		.form-input { display: inline-block; width: 48%; }
	}

	.security { margin-top: .5rem; text-align: right;
		img { opacity: .7; }
		a:hover img { opacity: 1; }
	}
	.total { margin-top: 1.1rem; .bold(); font-size: 1.5rem;
		table { width: 90%; margin: 0 auto;
			caption { margin: 1rem 0; .regular(); font-size: 1rem; }
			th { font-size: 1rem; text-align: left; }
			td { font-size: 1rem; text-align: right; }
		}
	}

	@media @mobile {
		form { padding: 6vw 3vw 12vw; }
		h3 { margin: 1em; }
	}
</style>



// WEBPACK FOOTER //
// src/components/TheForm/TheFormPayment.vue